/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recovery_ReadyInputs */

const en_us2_recovery_ready = /** @type {(inputs: Recovery_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`recovered`)
};

const pt_br2_recovery_ready = /** @type {(inputs: Recovery_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`recuperado`)
};

const es_419_recovery_ready = /** @type {(inputs: Recovery_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`recuperado`)
};

const pt_pt2_recovery_ready = /** @type {(inputs: Recovery_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`recuperado`)
};

const fr_fr2_recovery_ready = /** @type {(inputs: Recovery_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`récupéré`)
};

const de_de2_recovery_ready = /** @type {(inputs: Recovery_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`erholt`)
};

const it_it2_recovery_ready = /** @type {(inputs: Recovery_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`recuperato`)
};

/**
* | output |
* | --- |
* | "recovered" |
*
* @param {Recovery_ReadyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const recovery_ready = /** @type {((inputs?: Recovery_ReadyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_ReadyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_recovery_ready(inputs)
	if (locale === "es-419") return es_419_recovery_ready(inputs)
	if (locale === "pt-PT") return pt_pt2_recovery_ready(inputs)
	if (locale === "fr-FR") return fr_fr2_recovery_ready(inputs)
	if (locale === "de-DE") return de_de2_recovery_ready(inputs)
	if (locale === "it-IT") return it_it2_recovery_ready(inputs)
	return en_us2_recovery_ready(inputs)
});
export { recovery_ready as "recovery.ready" }